/**
 * Escala de z-index del design system v4 — fuente única de verdad de la pila vertical.
 *
 * INVARIANTE INNEGOCIABLE: lo OPERATIVO (pedidos) SIEMPRE gana. El toast de pedido
 * entrante (NotificationCenterV2, `z-[99]`, bottom-0 right-0 en desktop / w-full móvil)
 * queda por encima de TODA la UI de Paulina. Por eso:
 *
 *     pedido (99)  >  Paulina sheet/panel (95)  >  Paulina pill/coachmark (80)
 *
 * Nunca usar el `z-140/z-250` del molde de sheets v4 (QuickPresentationsSheet,
 * MobileTopBarV4 branch-sheet) para una superficie de Paulina: taparía el toast.
 *
 * Estos valores son los MISMOS números que ya viven inline en Tailwind (`z-[80]`,
 * `z-[95]`) y en el toast (`z-[99]`); este módulo los centraliza para que la
 * invariante quede documentada en un solo lugar y no diverja al editar componentes.
 */
export const Z = {
  /** Toast de pedido entrante — lo operativo, SIEMPRE arriba de Paulina. */
  pedido: 99,
  /** Chat de Paulina abierto: panel desktop / bottom-sheet móvil (cede ante pedido). */
  paulinaSheet: 95,
  /** Entrada de Paulina (pill desktop) + coachmark proactivo (debajo del pedido). */
  paulinaPill: 80,
} as const;

export type ZLayer = keyof typeof Z;
